import { Middleware } from "@reduxjs/toolkit";
import uiReducer from "../reducers/uiReducer";
import stateReducer from "../reducers/stateReducer";
import tempReducer from "../reducers/tempReducer";
import apiReducer from "../reducers/apiReducer";
import {
  TemplateTEMPObject,
  TemplateSTATEObject,
  TemplateUIObject,
} from "@services/storage/storeTemplate";
import { APIprocessor } from "./apiProcessor";
import { tempProcessor } from "./tempProcessor";
import { uiProcessor } from "./uiProcessor";

export interface PostProcess {
  (action: any, next: any): any;
}

const { actions: uiActions } = uiReducer;
const { actions: stateActions } = stateReducer;
const { actions: tempActions } = tempReducer;
const { actions: apiActions } = apiReducer;

const postProcess: PostProcess = (action, next) => {
  switch (action.type) {
    case apiActions.set.type:
      APIprocessor(action, next);
      break;

    case uiActions.set.type:
      uiProcessor(action, next);
      break;

    case tempActions.set.type:
    case stateActions.set.type:
      tempProcessor(action, next);
      break;

    default:
      return next(action);
  }
};

export interface MiddlewarePostProcessor {
  ({
    getState,
  }: {
    getState: () => {
      ui: TemplateUIObject;
      temp: TemplateTEMPObject;
      state: TemplateSTATEObject;
    };
  }): (next: any) => (action: any) => Promise<void>;
}

const middlewarePostProcessor: Middleware = () => (next) => async (action) => {
  postProcess(action, next);
};

export default middlewarePostProcessor;
